// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import type { CycleTimeReportFilter } from '@/report/api/types';
import {
  getInboundShipmentCycleTimeReport,
  serializeInboundShipmentCycleTimeReportFilter,
} from '@/shipment/api/get-inbound-shipment-cycle-time-report';
import { inboundShipmentCycleTimeReportQueryKey } from '@/shipment/hooks/use-shipments';
import { ONE_MINUTE_MS } from '@/utilities/time-constants';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

interface UseInboundShipmentCycleTimeReportOptions {
  filter?: CycleTimeReportFilter;
}

export function useInboundShipmentCycleTimeReport(
  options: UseInboundShipmentCycleTimeReportOptions = {}
) {
  const filterString = serializeInboundShipmentCycleTimeReportFilter(
    options.filter
  );
  const { data, ...query } = useQuery({
    queryKey: inboundShipmentCycleTimeReportQueryKey(filterString),
    queryFn: () => getInboundShipmentCycleTimeReport(options.filter),
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: true,
    staleTime: ONE_MINUTE_MS,
    throwOnError: true,
  });

  return { report: data?.data ?? null, ...query };
}
